import { PaginationDetails } from "./api_request";

export interface TimesheetDetails {
  _id: string;
  facility: string;
  shift: string;
  note: string;
  medic: string;
  medic_info: {
    name: string;
  };
  status: string;
  overtime_hours: string;
  clock_in_time: string;
  clock_out_time: string;
  created_at: string;
  total_hours: string;
  updated_at: string;
  shift_info: {
    start_time: string;
    end_time: string;
  };
}

export const TimesheetDetailsDummyData = {
  _id: "",
  facility: "",
  shift: "",
  note: "",
  medic: "",
  medic_info: {
    name: "",
  },
  overtime_hours: "",
  total_hours: "",
  status: "",
  clock_out_time: new Date().toISOString(),
  clock_in_time: new Date().toISOString(),
  created_at: new Date().toISOString(),
  updated_at: "",
};

export interface TimesheetContentProps {
  timesheetList: TimesheetDetails[];
  loading: boolean;
  setFilterData: React.Dispatch<React.SetStateAction<string>>;
  paginationState: PaginationDetails;
  setPaginationState: React.Dispatch<React.SetStateAction<PaginationDetails>>;
}

export interface TimesheetTableProps {
  data: TimesheetDetails[];
  handleModal: () => void;
  loading: boolean;
  setSelectedEmployeeId: React.Dispatch<React.SetStateAction<string>>;
}

export interface TimesheetDetailsProps {
  _id: string;
  facility: string;
  shift: string;
  note: string;
  medic: string;
  status: string;
  clock_in_time: string;
  created_at: string;
  updated_at: string;
  flag_note: string;
  medic_info: {
    email: string;
    dob: string;
    first_name: string;
    gender: string;
    last_name: string;
    medic_type: string;
  };
  employee_info: {
    _id: string;
  };
}

export const TimesheetDetailsPropsDummyData = {
  _id: "",
  facility: "",
  shift: "",
  note: "",
  medic: "",
  status: "",
  clock_in_time: "",
  created_at: "",
  updated_at: "",
  flag_note: "",
  medic_info: {
    email: "",
    dob: "",
    first_name: "",
    gender: "",
    last_name: "",
    medic_type: "",
  },
  employee_info: {
    _id: "",
  },
};

export interface TimesheetModalProps {
  paginationState: PaginationDetails;
  setPaginationState: React.Dispatch<React.SetStateAction<PaginationDetails>>;
  open: boolean;
  modalHandler: () => void;
  medicData: TimesheetMedicContentProps[];
}

export interface TimesheetMedicContentProps {
  _id: string;
  facility: string;
  facility_info: {
    name: string;
    facility_type: string;
  };
  shift_info: {
    start_time: string;
    end_time: string;
    employee: string;
    created_at: string;
    schedule: string;
    schedule_name: string;
  };
  shift: string;
  medic: string;
  medic_info: {
    name: string;
    medic_type: string;
  };
  status: string;
  clock_in_time: string;
  created_at: string;
  updated_at: string;
  clock_out_time: string;
  overtime_hours: number;
  total_hours: number;
}

export const TimesheetMedicContentPropsDummyData = {
  _id: "",
  facility: "",
  facility_info: {
    name: "",
    facility_type: "",
  },
  shift_info: {
    start_time: "",
    end_time: "",
    employee: "",
    created_at: "",
    schedule: "",
    schedule_name: "",
  },
  shift: "",
  medic: "",
  medic_info: {
    name: "",
    medic_type: "",
  },
  status: "",
  clock_in_time: "",
  created_at: "",
  updated_at: "",
  clock_out_time: "",
  overtime_hours: 0,
  total_hours: 0,
};

export interface TimesheetData {
  _id: string;
  facility: string;
  facility_info: {
    name: string;
    facility_type: string;
  };
  shift_info: {
    start_time: string;
    end_time: string;
    employee: string;
    created_at: string;
    schedule: string;
    schedule_name: string;
  };
  shift: string;
  medic: string;
  medic_info: {
    name: string;
    medic_type: string;
  };
  status: "pending" | "approved" | "rejected";
  clock_in_time?: string;
  clock_out_time?: string;
  overtime_hours?: number;
  total_hours?: number;
  created_at: string;
  updated_at: string;
}

export interface ShiftData {
  _id: string;
  schedule: string;
  employee: string;
  start_time: string;
  end_time: string;
  status: "pending" | "completed" | "cancelled" | "absent";
  facility: string;
  facility_info: {
    name: string;
    email: string;
    facility_type: string;
  };
  employee_info: {
    job_type: string;
    department: string;
  };
  schedule_info: {
    schedule_name: string;
    start_date: string;
    end_date: string;
  };
  medic: string;
  medic_info: {
    name: string;
    medic_type: string;
  };
  created_at: string;
  updated_at: string;
}
